// extracted by mini-css-extract-plugin
export default {"products":"sy-z","card":"ty-z","oosMessaging":"uy-z"};